import { AssetType, TypeArray } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"

export type SnapShotRef = {
  id: string
  version: string
}

const reducerAction = {
  id: actionCreatorTypeGuard<SnapShotRef, string>("id", "SnapShotRef"),
  version: actionCreatorTypeGuard<SnapShotRef, string>(
    "version",
    "SnapShotRef"
  ),
  __record: actionCreatorTypeGuard<TypeArray, SnapShotRef>(
    "SnapShotRef",
    "__record"
  ),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<SnapShotRef>>(
    "create",
    "__create/SnapShotRef"
  ),
  __delete: actionCreatorTypeGuard<TypeArray, number>("delete", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof SnapShotRef
    | "__record"
    | "__delete"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const snapShotRefAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const snapShotRefReducer = reducerTypeGuard<SnapShotRef>()
  .case(...reducerAction.id)
  .case(...reducerAction.version)
  .build()
